// extracted by mini-css-extract-plugin
module.exports = {"mascot-root_animation":"Mascot_mascot-root_animation__1CNDv","mascot-float":"Mascot_mascot-float__2DL1-","mascot-root":"Mascot_mascot-root__1dSD_"};